import { render, staticRenderFns } from "./index.vue?vue&type=template&id=106c86ed"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106c86ed')) {
      api.createRecord('106c86ed', component.options)
    } else {
      api.reload('106c86ed', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=106c86ed", function () {
      api.rerender('106c86ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/index.vue"
export default component.exports